// src/components/MultiStepForm/FormStep.js

import React, {useEffect} from "react";
import { useForm, FormProvider, useWatch } from "react-hook-form";
import css from "./style.scss";
import classNames from "classnames";

const FormStep = ({
  defaultValues,
  validationSchema,
  onNext,
  onBack,
  backButtonLabel = "Back",
  showNextButton = true,
  showBackButton = true,
  showCancelButton = false,
  CancelButtonLabel = 'Cancel',
  continueButtonLabel = 'Continue',
  onCancel,
  children,
  isLoading = false,
}) => {
  const methods = useForm({
    defaultValues,
    resolver: async (data) => {
      try {
        await validationSchema.validate(data, { abortEarly: false });
        return { values: data, errors: {} };
      } catch (validationErrors) {
        if (validationErrors.inner) {
          const errors = validationErrors.inner.reduce((allErrors, currentError) => {
            allErrors[currentError.path] = { message: currentError.message };
            return allErrors;
          }, {});
          
          return { values: {}, errors };
        }
        // Handle edge cases where validationErrors.inner is undefined
        return {
          values: {},
          errors: { form: { message: validationErrors.message || "Validation failed" } },
        };
      }
    },
    mode: "onSubmit",
  });

  const { handleSubmit, formState, trigger, control, getValues } = methods;
  // isSubmitting lives on formState in react-hook-form v7; it stays true while onSubmit's promise is pending
  const { isSubmitting } = formState;

  const newPwd = useWatch({ control, name: "newPwd" });

  const username = useWatch({ control, name: "username" });

  // Revalidate confirmEmail when username changes
  useEffect(() => {
    trigger("confirmEmail");
  }, [username, trigger]);

  useEffect(() => {
    if (getValues("confirmPassword")) {
      trigger("confirmPassword");
    }
  }, [newPwd, trigger, getValues]);

  const onSubmit = async (values) => {
    await onNext(values); // Proceed to the next step; awaited so the buttons stay disabled until it finishes
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div>{children}</div>
        <div className={css.clsInnerFooter}>

        {showCancelButton && (
            <button
              className={classNames(css.btn_xl, css.btn_primary, css.clsBtnPrimaryGreen)}
              type="button"
              onClick={onCancel}
              disabled={isSubmitting}
            >
              {CancelButtonLabel}
            </button>
          )}

          {showBackButton && onBack && (
            <button
              className={classNames(css.btn_xl, css.btn_primary, css.clsBtnPrimaryGreen)}
              type="button"
              onClick={onBack}
              disabled={isSubmitting}
            >
              {backButtonLabel}
            </button>
          )}
          {showNextButton && (
            <button
              type="submit"
              className={classNames(css.btn_xl, css.btn_primary, css.clsBtnOrng)}
              disabled={isSubmitting || isLoading}
            >
              {continueButtonLabel}
            </button>
          )}
        </div>
      </form>
    </FormProvider>
  );
};

export default FormStep;